export default function Identificacao() {
  const situacoes = [
    { icon: 'ri-capsule-line', text: 'Ele recusa tomar remédio' },
    { icon: 'ri-water-flash-line', text: 'Não quer tomar banho' },
    { icon: 'ri-repeat-line', text: 'Repete a mesma pergunta muitas vezes' },
    { icon: 'ri-emotion-unhappy-line', text: 'Acusa familiares de coisas que não aconteceram' },
    { icon: 'ri-brain-line', text: 'Fica irritado quando você tenta ajudar' },
    { icon: 'ri-moon-line', text: 'Se agita no fim do dia' },
  ];

  return (
    <section className="py-12 sm:py-20 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">

          {/* Coluna Esquerda - Foto */}
          <div className="relative order-last lg:order-first mt-6 lg:mt-0">
            <div className="relative w-full h-[260px] sm:h-[360px] lg:h-[520px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/a7482cdea09e06f57380774ccfaa1e57.jpg"
                alt="Cuidadora exausta e preocupada"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Coluna Direita - Texto + Cards */}
          <div className="space-y-7">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 leading-tight">
              Talvez você já tenha vivido situações assim
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {situacoes.map((situacao, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-teal-50/60 border border-teal-100 rounded-xl px-4 py-3"
                >
                  <div className="w-9 h-9 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className={`${situacao.icon} text-teal-600 text-lg`}></i>
                  </div>
                  <p className="text-gray-800 text-sm leading-snug">
                    {situacao.text}
                  </p>
                </div>
              ))}
            </div>

            <div className="border-l-4 border-teal-500 pl-5 py-1">
              <p className="text-base text-gray-600 mb-2">E muitas vezes surge a sensação de:</p>
              <p className="text-xl sm:text-2xl font-bold text-gray-900 italic">
                &ldquo;Eu não sei mais o que fazer.&rdquo;
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
